export const option_api_method = [
  { name: "GET", value: "get" },
  { name: "POST", value: "post" },
];
